/**
 * Created by Jie Gao on 2017-12-06.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DragonTribeGameAssets} from "../../DragonTribeGameAssets";
import {Sine, TimelineLite, TweenLite, TweenMax} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {DragonTribeGameModuleConfig} from "../../DragonTribeGameModuleConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IPickAndClickViewConfig, PickAndClickView} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickView";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {IBackPlateMeshConfig} from "@nolimitcity/slot-game/bin/core/displayobject/BasePlateMesh";
import {ButtonLike} from "@nolimitcity/slot-game/bin/core/component/Button";
import {DragonTribe} from "../../DragonTribe";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class DTFreespinIntroScreenView extends PickAndClickView {
    private readonly _buttonKeywords:string[] = ["START", "START"];
    private readonly _transformWildText:string = "Every third winning cascade will turn one of the five dragons into Wild and award +2 spins.";
    private readonly _textPage1:string = "Win more often";
    private readonly _winUpTo:string = "win more than";
    private readonly _bet:string = " bet";
    private readonly _textPage2:string = "High risk, high potential";
    private readonly _pageX:number[] = [-200, 200];
    private readonly _pageY:number[] = [210, 210];
    private readonly _buttonBackgroundConfig:IBackPlateMeshConfig = {
        cornerRadius : 12,
        lineThickness : 2,
        lineColor : 0xffffff,
        lineAlpha : 1,
        backgroundColor : 0x000000,
        backgroundAlpha : 0
    };
    private readonly _buttonTextStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontStyle : FontStyle.ITALIC,
        fontSize : 34,
        fill : 0xffffff,
        fontWeight : FontWeight.EXTRA_BOLD,
        wordWrap : true,
        wordWrapWidth : 250
    };
    private readonly _bigTextStyle:any = {
        fill : 0xffffff,
        fontFamily : "Open Sans",
        wordWrap : true,
        wordWrapWidth : 700,
        fontWeight : FontWeight.BOLD,
        fontSize : 26,
        breakWords:true
    };
    private readonly _pageTextStyle:any = {
        fill : 0xffffff,
        fontFamily : "Open Sans",
        wordWrap : true,
        wordWrapWidth : 400,
        fontWeight : FontWeight.BOLD,
        fontSize : 22
    };
    private readonly _winUpToTextStyle:any = {
        fill : 0xffffff,
        fontFamily : "Open Sans",
        wordWrap : true,
        wordWrapWidth : 400,
        fontWeight : FontWeight.BOLD,
        fontSize : 16
    };
    private _playFeatureStartSoundCallback:() => void;
    private _pageWinUpTo:PIXI.Text[][] = [];
    private _dragonSpins:PIXI.Sprite;
    private _iconWild:PIXI.Sprite;
    private _infoPanelBG:PIXI.Sprite;
    private _symbolExplain:PIXI.Sprite;
    private _bar:PIXI.Sprite;
    private _dragonspinsText:PIXI.Sprite;
    private _infoPanel:PIXI.Container;
    private _fsWon:PIXI.BitmapText;
    private _bgTextures:string;
    private _modePages:PIXI.Sprite[];
    private _container:PIXI.Container;
    private _darkOverlay:PIXI.Graphics;
    private _pageGlow:PIXI.Sprite;

    constructor(config:IPickAndClickViewConfig) {
        super(config, false);
        this._bgTextures = DragonTribeGameAssets.INTRO_BACKGROUND;
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();
        this._infoPanel = new PIXI.Container();
        this._darkOverlay = new PIXI.Graphics;
        container.addChild(this._darkOverlay);

        this._dragonSpins = new PIXI.Sprite(GameResources.getTextures("dragonspins")[0]);
        this._dragonSpins.anchor.set(0.5, 0.5);
        this._dragonSpins.position.set(0, -50);

        this._infoPanelBG = new PIXI.Sprite();
        this._infoPanelBG.anchor.set(0.5, 0.5);
        this._infoPanelBG.position.set(0, -50);

        this._iconWild = new PIXI.Sprite(GameResources.getTextures("icon_wild")[0]);
        this._iconWild.anchor.set(0.5, 0.5);
        this._iconWild.position.set(-200, -130);

        this._dragonspinsText = new PIXI.Sprite(GameResources.getTextures("dragonspinsText")[0]);
        this._dragonspinsText.anchor.set(0.5, 0.5);
        this._dragonspinsText.position.set(50, -240);

        const symbolExplain:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsIntroSymbolExplain")[0]);
        symbolExplain.anchor.set(0.5, 0.5);
        symbolExplain.scale.set(0.5, 0.5);
        symbolExplain.position.set(0, -40);
        this._symbolExplain = symbolExplain;

        this._pageGlow = new PIXI.Sprite(GameResources.getTextures("fsIntroPageGlow")[0]);
        this._pageGlow.anchor.set(0.5, 0.5);
        this._pageGlow.scale.set(0.8, 0.8);
        this._pageGlow.alpha = 0;
        this._pageGlow.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._infoPanelBG.addChild(this._pageGlow);
        this.createModePages();

        const infoText:PIXI.Text = new PIXI.Text(Translation.translate(this._transformWildText), this._bigTextStyle);
        infoText.position.y = -215;
        infoText.position.x = 0 - infoText.width / 2;
        const bar:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsIntroBar")[0]);
        bar.anchor.set(0.5, 0.5);
        this._bar = bar;

        this._infoPanelBG.addChild(symbolExplain);
        this._infoPanelBG.addChild(this._dragonspinsText);
        this._infoPanelBG.addChild(bar);
        this._infoPanelBG.addChild(infoText);

        this._fsWon = new PIXI.BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 16,
            tint : 0xffffff
        });

        this._infoPanel.addChild(this._infoPanelBG);
        this._dragonSpins.addChild(this._iconWild);
        this._infoPanel.addChild(this._dragonSpins);
        this._dragonSpins.alpha = 0;
        this._iconWild.alpha = 0;
        this._infoPanelBG.alpha = 0;
        this._fsWon.alpha = 0;
        this._dragonSpins.scale.set(0.5, 0.5);
        container.addChild(this._infoPanel);
        this._container = container;
        return container;
    }

    private createModePages():void {
        this._modePages = [];
        this._pageWinUpTo = [];
        this._buttonKeywords.forEach((key:string, i:number) => {
            const page:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(`fsIntroMode${(i === 0) ? "A" : "B"}`)[0]);
            page.anchor.set(0.5, 0.5);
            page.position.set(this._pageX[i], this._pageY[i]);
            page.scale.set(0.8, 0.8);
            this._modePages.push(page);
        });

        const page1Text:PIXI.Text = new PIXI.Text(Translation.translate(this._textPage1), this._pageTextStyle);
        page1Text.anchor.set(0);
        page1Text.position.y = 258 - page1Text.height;
        page1Text.position.x = -110;

        const page2Text:PIXI.Text = new PIXI.Text(Translation.translate(this._textPage2), this._pageTextStyle);
        page2Text.position.y = 258;
        page2Text.position.x = 150;
        page2Text.anchor.set(1);

        if (DragonTribe.api.gameClientConfiguration.isSet) {
            this.addText(page1Text,0);
            this.addText(page2Text,1);
        } else {
            DragonTribe.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.addText(page1Text,0);
                this.addText(page2Text,1);
            });
        }

        // DragonTribe.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
        //     if (DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx !== false) {
        //         this._modePages[0].addChild(page1Text);
        //         this._pageWinUpTo.push(this.addWinUpToText(this._modePages[0], "11 000x"));
        //     }
        // });
        this._infoPanelBG.addChild(this._modePages[0]);

        // DragonTribe.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
        //     if (DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx!==false) {
        //         this._modePages[1].addChild(page2Text);
        //         this._pageWinUpTo.push(this.addWinUpToText(this._modePages[1], "27 000x"));
        //     }
        // });

        this._infoPanelBG.addChild(this._modePages[1]);
    }

    private addText(text:PIXI.Text,idx:number):void{
        if (DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx!==false) {
            this._modePages[idx].addChild(text);
            this._pageWinUpTo.push(this.addWinUpToText(this._modePages[idx], idx===0?"11 000x":"27 000x"));
        }
    }
    private addWinUpToText(page:PIXI.Sprite, timeBet:string):PIXI.Text[] {
        const page1WinUpTo:PIXI.Text = new PIXI.Text(Translation.translate(this._winUpTo), this._winUpToTextStyle);
        page1WinUpTo.anchor.set(0.5);
        page1WinUpTo.position.y = -45;
        page1WinUpTo.position.x = 0;
        page.addChild(page1WinUpTo);
        const page1TimesBet:PIXI.Text = new PIXI.Text(timeBet, this._pageTextStyle);
        page1TimesBet.anchor.set(0);
        page1TimesBet.position.y = -30;
        page.addChild(page1TimesBet);
        const page1Bet:PIXI.Text = new PIXI.Text(Translation.translate(this._bet), this._winUpToTextStyle);
        page1Bet.anchor.set(0);
        page1Bet.position.y = -25;
        const textLength:number = page1Bet.width + page1TimesBet.width;
        page1TimesBet.position.x = -textLength / 2;
        page1Bet.position.x = -textLength / 2 + page1TimesBet.width;
        page.addChild(page1Bet);

        return [page1WinUpTo, page1TimesBet, page1Bet];
    }

    protected createButton(index:number, selectedIndex:number, clickCallback:(i:number, auto:boolean) => void):NineSliceButton {
        const keyword:string = Translation.translate(this._buttonKeywords[index]);
        const button = new NineSliceButton(() => {
            clickCallback(selectedIndex, this._autoClicked);
        }, keyword, this._buttonTextStyle, this._buttonBackgroundConfig);
        button.position.set(0, 120);
        button.enabled = false;
        button.setSize(260, 60, 1);
        this._modePages[index].addChild(button);
        return button;
    }

    protected onResizeButtons(resizeData:IResizeData):void {
        // resize together with onResizeGameGraphics
    }


    protected startPresentation(data:ParsedServerData, completeFunction:() => {}):void {
        const fs:number = 0.033;
        this._fsWon.text = data.freespinsLeft.toString();
        this._dragonSpins.addChild(this._fsWon);
        this._fsWon.position.set(0 - this._fsWon.width / 2, -180);
        this._dragonSpins.alpha = 0;
        this._iconWild.alpha = 0;
        this._infoPanelBG.alpha = 0;
        this._fsWon.alpha = 0;
        this._fsWon.scale.set(1, 1);
        this._pageGlow.alpha = 0;
        this._dragonSpins.scale.set(1, 1);
        this._iconWild.scale.set(2.25, 2.25);
        this.disableButtons();
        this._modePages.forEach((page:PIXI.Sprite) => {
            page.alpha = 1;
            page.tint = 0xffffff;
        });
        this._pageWinUpTo.forEach((winUpToText:PIXI.Text[]) => {
            winUpToText.forEach((text:PIXI.Text) => {
                text.tint = 0xffffff;
            });
        });
        const selectedIndex:number = (<DragonTribeParsedGameData>data)!.playerFSSelection;
        const isRestore:boolean = (selectedIndex > 0);
        const page0Tl:TimelineLite = new TimelineLite();

        page0Tl.add([
            TweenLite.fromTo(this._iconWild.scale, 4 * fs, {x : 2.25, y : 2.25}, {x : 1.1, y : 1.1}),
            TweenLite.fromTo(this._iconWild, fs, {alpha : 0}, {alpha : 1})
        ], 0);
        page0Tl.add(TweenLite.fromTo(this._iconWild.scale, 2 * fs, {x : 1.1, y : 1.1}, {x : 1, y : 1}), 4 * fs);
        const tl:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => {
                super.startPresentation(data, completeFunction);
                this._infoPanel.removeChild(this._fsWon);
            }
        });
        tl.add([
            () => {
                SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_INTRO);
                SlotGame.sound.fadeAmbience(0, 500);
                SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_INTRO_FIRE, -1);
            },
            TweenLite.to(this._fsWon, fs, {alpha : 0}),
            TweenLite.fromTo(this._iconWild, 6 * fs, {alpha : 0}, {alpha : 0}),
            TweenLite.fromTo(this._dragonSpins, 2 * fs, {alpha : 0}, {alpha : 1}),
            TweenLite.fromTo(this._fsWon, 6 * fs, {alpha : 0}, {alpha : 1}),
            TweenLite.fromTo(this._dragonSpins.scale, 6 * fs, {x : 0.5, y : 0.5}, {x : 1.1, y : 1.1})
        ], fs);
        tl.add(TweenLite.fromTo(this._dragonSpins.scale, 6 * fs, {x : 1.1, y : 1.1}, {x : 1, y : 1}), 6 * fs);

        tl.add(page0Tl, 18 * fs);
        tl.add([
            () => {
                this._infoPanelBG.addChild(this._fsWon);
                this._fsWon.scale.set(0.6, 0.6);
                this._fsWon.position.set(-190 - this._fsWon.width / 2, -270);
                if(isRestore) {
                    this._modePages.forEach((page:PIXI.Sprite, id:number) => {
                        if(id !== (selectedIndex - 1)) {
                            page.tint = 0x555555;
                        }
                    });
                    this._pageWinUpTo.forEach((winUpToText:PIXI.Text[], id:number) => {
                        if(id !== (selectedIndex - 1)) {
                            winUpToText.forEach((text:PIXI.Text) => {
                                text.tint = 0x555555;
                            });
                        }
                    });
                }
            },
            TweenLite.to(this._infoPanelBG, 0.1, {alpha : 1}),
            TweenLite.to(this._fsWon, 0.1, {alpha : 1}),
            TweenLite.to(this._dragonSpins, 0.1, {alpha : 0}),
            TweenLite.fromTo(this._infoPanelBG.scale, 1, {x : 0.7, y : 0.7}, {x : 1, y : 1})
        ], 19 * fs + 1);
        const startTime:number = tl.duration();
        this._buttons.forEach((button:ButtonLike, id:number) => {
            tl.add([() => {
               button.enabled = !isRestore;
            }, TweenLite.to(button, 0.1, {alpha : 1})], startTime);
        });

        tl.play();
    }

    public wait():void {
        // TODO
    }

    protected stopPresentation(data?:ParsedServerData, closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        const selectedIndex:number = (<DragonTribeParsedGameData>data)!.playerFSSelection - 1;
        if(selectedIndex < 0 || selectedIndex > 1) {
        debugger;
            throw new Error(`DTFreespinIntroScreenView.stopPresentation(): illegal data.playerFSSelection!`);
        }
        this._modePages.forEach((page:PIXI.Sprite, id:number) => {
            if(id !== selectedIndex) {
                page.tint = 0x555555;
            }
        });
        this._pageWinUpTo.forEach((winUpToText:PIXI.Text[], id:number) => {
            if(id !== selectedIndex) {
                winUpToText.forEach((text:PIXI.Text) => {
                    text.tint = 0x555555;
                });
            }
        });
        this._pageGlow.position.x = this._pageX[selectedIndex];
        this._buttons.forEach((button:ButtonLike) => {
            button.enabled = false;
            DragonTribeGameModuleConfig.soundPlayer.switchToFreespinMusic();
        });
        timeline.add(TweenMax.to(this._pageGlow, 0.8, {alpha : 0.7, repeat : 3, ease : Sine.easeInOut}));
        timeline.add("close", "+=2");
        timeline.add(() => super.stopPresentation(data, closeCallback));
        timeline.play();
        DragonTribeGameModuleConfig.background.showRedOverlay();
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        let offset:number = 0;
        if(resizeData.orientation == Orientation.PORTRAIT) {
            const isIPad:boolean = resizeData.width / resizeData.height >= 0.76;
            offset = isIPad ? 150 : 0;
            this._infoPanel.scale.set(1.7, 1.7);
            this._symbolExplain.scale.set(1, 1);
            this._symbolExplain.position.set(0, 30);
            this._modePages.forEach((page:PIXI.Sprite) => {
                page.y = 320;
            });
            this._bar.position.set(0, 540);
            this._pageGlow.position.y = 320;
        } else {
            this._bar.position.set(0, 390);
            this._infoPanel.scale.set(1, 1);
            this._symbolExplain.scale.set(0.7, 0.7);
            this._symbolExplain.position.set(0, -60);
            this._modePages.forEach((page:PIXI.Sprite) => {
                page.y = 170;
            });
            this._pageGlow.position.y = 170;
        }
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5-offset);
        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(-this._screenWidth / 2, -this._screenHeight / 2, this._screenWidth, this._screenHeight+offset);
    }

    public disableButtons():void{
        this._buttons.forEach((button:ButtonLike) => {
            button.enabled = false;
        });
    }
    public getFeatureStartSoundCallback(playSoundCallback:() => void):void {
        this._playFeatureStartSoundCallback = playSoundCallback;
    }
}
